import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
// eslint-disable-next-line
import SectionHeroArchivePage from "components/SectionHeroArchivePage/SectionHeroArchivePage";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import { TaxonomyType } from "data/types";
import React, { FC } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";

export interface ListingCarPageProps {
  className?: string;
}

const DEMO_CATS: TaxonomyType[] = [
  {
    id: "2",
    href: "/category/outdoor",
    name: "Outdoor",
    taxonomy: "category",
    count: 188288,
    thumbnail: "https://renttrips.id/wp-content/uploads/2021/09/Outdoor-1.png",
  },
  {
    id: "2",
    href: "/category/gadget",
    name: "Gadget",
    taxonomy: "category",
    count: 188288,
    thumbnail: "https://renttrips.id/wp-content/uploads/2021/09/Gadget-1.png",
  },
  {
    id: "1",
    href: "/category/transportasi",
    name: "Transportasi",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://renttrips.id/wp-content/uploads/2021/09/Transport-1.png",
  },
  {
    id: "2",
    href: "/category/pakaian",
    name: "Pakaian",
    taxonomy: "category",
    count: 188288,
    thumbnail: "https://renttrips.id/wp-content/uploads/2021/09/Pakaian-1.png",
  },
  {
    id: "2",
    href: "/category/keperluan Anak",
    name: "Keperluan Anak",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://renttrips.id/wp-content/uploads/2021/09/Keperlluan-Anak-1.png",
  },
  {
    id: "2",
    href: "/category/furnitur",
    name: "Furnitur",
    taxonomy: "category",
    count: 188288,
    thumbnail: "https://renttrips.id/wp-content/uploads/2021/09/Furnitur-1.png",
  },

  {
    id: "2",
    href: "/category/keperluan Pribadi",
    name: "Keperluan Pribadi",
    taxonomy: "category",
    count: 188288,
    thumbnail:
      "https://renttrips.id/wp-content/uploads/2021/09/Keperluan-Pribadi-1.png",
  },
];

const ListingCarPage: FC<ListingCarPageProps> = ({ className = "" }) => {
  const { category } = useParams<{ category?: string }>();

  return (
    <div
      className={`nc-ListingCarPage relative overflow-hidden ${className}`}
      data-nc-id="ListingCarPage"
    >
      <Helmet>
        <title>Chisfis || Booking React Template</title>
      </Helmet>
      <BgGlassmorphism />

      <div className="container relative">
        {/* SECTION HERO */}
        {/* <SectionHeroArchivePage
          currentPage="Rental car"
          currentTab="Rental car"
          listingType={
            <>
              <i className="text-2xl las la-car"></i>
              <span className="ml-2.5">1512 cars</span> */}
        {/*Diubah jadi props */}
        {/* </>
          }
          className="pt-10 pb-24 lg:pb-32 lg:pt-28 "
        /> */}

        {/* SECTION */}
        <SectionGridFilterCard className="pb-24 lg:py-16" heading={category} />

        {/* SECTION 1 */}
        <div className="relative py-16">
          <BackgroundSection />
          <SectionSliderNewCategories
            heading="Kategori"
            subHeading="Temukan Barang Sesuai Kategori"
            categoryCardType="card3"
            itemPerRow={5}
            categories={DEMO_CATS}
            sliderStyle="style2"
          />
        </div>

        {/* SECTION */}
        <SectionSubscribe2 className="py-24 lg:py-32" />
      </div>
    </div>
  );
};

export default ListingCarPage;
